import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_none",
  "use": "svg_none-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"svg_none\"><path d=\"M7 .333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 7 .333ZM1.163 7a5.83 5.83 0 0 1 9.63-4.444L2.6 10.852A5.8 5.8 0 0 1 1.163 7ZM7 12.83a5.793 5.793 0 0 1-3.815-1.43L11.4 3.185a5.822 5.822 0 0 1-4.4 9.63v.015Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol